import { UserDetailsService } from "../components/core/_request";

export const useAuth = () => {
  const getStoredProfile = () => {
    try {
      const profileData = localStorage.getItem("profile");
      if (!profileData) return null;
      
      const profile = JSON.parse(profileData);
      // Ensure UserId exists and is valid
      if (!profile.UserId || profile.UserId === 'undefined' || profile.UserId === 'null') {
        console.warn('Invalid UserId in stored profile:', profile.UserId);
        return null;
      }
      return profile;
    } catch (error) {
      console.error('Error parsing stored profile:', error);
      localStorage.removeItem("profile"); // Clear corrupted data
      return null;
    }
  };

  return ({
    currentUser: getStoredProfile(),
  isLogedIn: async () => {
    const Authorization = localStorage.getItem("Authorization");
    if (Authorization) {
      var UserDetails = await UserDetailsService().then((resp) => resp.data);
      return UserDetails?.ResponseCode == 200 ?? false;
    }
    return false;
  },
  userType: {
    EXPERT: 3,
    ENDUSER: 4,
  },
  setCurrentUser: (profile) => {
    if (!profile) {
      console.error('Attempted to set null/undefined profile');
      return;
    }
    
    // Validate required fields
    if (!profile.UserId || profile.UserId === 'undefined' || profile.UserId === 'null') {
      console.error('Invalid profile data - missing or invalid UserId:', profile);
      return;
    }
    
    localStorage.setItem("profile", JSON.stringify(profile));
    window.dataLayer.push({
      'event': 'U_login',
      'user_id': profile?.UserId
    })
  },
  login: (data) => {
    localStorage.setItem(
      "Authorization",
      data.usertoken
    );
    let now = new Date();
    let oneYearFromNow = new Date(now.setFullYear(now.getFullYear() + 1));
    let firstName = data?.userdetails?.Name.split(" ").slice(0, 1).join("");
    document.cookie = `displayName=${firstName};expires=${oneYearFromNow.toUTCString()};domain=.unitedwecare.com;path=/;`;
  },
  logout: () => {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("profile");
    let now = new Date();
    let oneYearFromNow = new Date(now.setFullYear(now.getFullYear() + 1));
    document.cookie = `userType=${null};expires=${oneYearFromNow.toUTCString()};domain=.unitedwecare.com;path=/;`;
    document.cookie = `displayName=${null};expires=${oneYearFromNow.toUTCString()};domain=.unitedwecare.com;path=/;`;
  },
  updateMobileNo: (mobileNumber) => {
    var profileJSON = localStorage.getItem("profile");
    var profile = JSON.parse(profileJSON);
    profile.MobileNo = mobileNumber;
    var updatedProfileJSON = JSON.stringify(profile);
    localStorage.setItem("profile", updatedProfileJSON);
  },
  // Helper method to get expert ID safely
  getExpertId: () => {
    const profile = getStoredProfile();
    return profile?.UserId || null;
  },
  // Helper method to check if user is expert
  isExpert: () => {
    const profile = getStoredProfile();
    return profile?.UserType === 3; // EXPERT type
  }
});
};
